import { createFeature, createReducer, on } from '@ngrx/store';

import { Profile } from '../models/profile';
import { AuthActions } from './auth.actions';

export interface AuthState {
  ready: boolean;
  userId: string | null;
  profile: Profile | null;
  passwordRecovery: boolean;
  pending: boolean;
  googlePending: boolean;
}

export const initialAuthState: AuthState = {
  ready: false,
  userId: null,
  profile: null,
  passwordRecovery: false,
  pending: false,
  googlePending: false,
};

const authReducer = createReducer(
  initialAuthState,
  on(AuthActions.initSuccess, (state, { userId, passwordRecovery, profile }) => ({
    ...state,
    ready: true,
    userId,
    passwordRecovery,
    profile,
  })),
  on(AuthActions.sessionChanged, (state, { userId, event }) => ({
    ...state,
    userId,
    passwordRecovery:
      event === 'PASSWORD_RECOVERY'
        ? true
        : event === 'SIGNED_OUT'
          ? false
          : state.passwordRecovery,
    profile: event === 'SIGNED_OUT' ? null : state.profile,
  })),
  on(AuthActions.profileLoaded, (state, { profile }) => ({
    ...state,
    profile,
  })),
  on(AuthActions.signInWithEmail, (state) => ({
    ...state,
    pending: true,
  })),
  on(AuthActions.signInWithGoogle, (state) => ({
    ...state,
    googlePending: true,
  })),
  on(
    AuthActions.signUp,
    AuthActions.resetPassword,
    AuthActions.updatePassword,
    AuthActions.setUsername,
    AuthActions.signOut,
    AuthActions.exchangeCode,
    (state) => ({
      ...state,
      pending: true,
    }),
  ),
  on(AuthActions.signUpSuccess, AuthActions.resetPasswordSuccess, (state) => ({
    ...state,
    pending: false,
  })),
  on(AuthActions.updatePasswordSuccess, (state) => ({
    ...state,
    pending: false,
    passwordRecovery: false,
  })),
  on(AuthActions.setUsernameSuccess, (state, { profile }) => ({
    ...state,
    pending: false,
    profile,
  })),
  on(AuthActions.signOutSuccess, () => ({
    ...initialAuthState,
    ready: true,
  })),
  on(AuthActions.authFlowSuccess, (state) => ({
    ...state,
    pending: false,
    googlePending: false,
  })),
  on(
    AuthActions.signInFailed,
    AuthActions.signUpFailed,
    AuthActions.resetPasswordFailed,
    AuthActions.updatePasswordFailed,
    AuthActions.setUsernameFailed,
    AuthActions.exchangeCodeFailed,
    (state) => ({
      ...state,
      pending: false,
      googlePending: false,
    }),
  ),
);

export const authFeature = createFeature({
  name: 'auth',
  reducer: authReducer,
});
